import React from 'react';
import SVGUniqueID from 'react-svg-unique-id';

const WhatsAppIconSolidCircular = () => (
  <SVGUniqueID>
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_1145_6470"
        style={{
          maskType: 'luminance'
        }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={24}
        height={24}
      >
        <path
          d="M24 12C24 18.6274 18.6274 24 12 24C5.37263 24 0 18.6274 0 12C0 5.37263 5.37263 9.47714e-06 12 9.47714e-06C18.6274 9.47714e-06 24 5.37263 24 12Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_1145_6470)">
        <path
          d="M24 12C24 18.6274 18.6274 24 12 24C5.37263 24 0 18.6274 0 12C0 5.37263 5.37263 9.47714e-06 12 9.47714e-06C18.6274 9.47714e-06 24 5.37263 24 12Z"
          fill="url(#paint0_linear_1145_6470)"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.858 13.3467C15.6677 13.2514 14.7326 12.7913 14.5582 12.728C14.3838 12.6645 14.2571 12.6327 14.1301 12.8231C14.0036 13.0133 13.6389 13.4418 13.528 13.5687C13.4171 13.6955 13.3061 13.7115 13.1159 13.6162C12.9257 13.5211 12.3129 13.3204 11.5863 12.6725C11.0208 12.1684 10.6391 11.5456 10.5282 11.3552C10.4173 11.1648 10.5163 11.0619 10.6114 10.9671C10.6971 10.882 10.8018 10.7451 10.8969 10.634C10.992 10.523 11.0236 10.4436 11.0869 10.3168C11.1506 10.1899 11.1188 10.0788 11.0711 9.98365C11.0237 9.88837 10.6432 8.95254 10.4848 8.57174C10.3303 8.20108 10.1737 8.25121 10.0567 8.24534C9.94596 8.23983 9.81903 8.23876 9.69227 8.23876C9.56552 8.23876 9.35947 8.28622 9.18507 8.47662C9.01067 8.66702 8.5193 9.12694 8.5193 10.0629C8.5193 10.9988 9.20089 11.9029 9.29601 12.0299C9.39112 12.1568 10.6372 14.0775 12.5452 14.9012C12.9991 15.0971 13.3534 15.214 13.6297 15.3017C14.0853 15.4464 14.5001 15.426 14.8277 15.3771C15.1931 15.3225 15.9531 14.917 16.1117 14.4727C16.2702 14.0286 16.2702 13.648 16.2226 13.5687C16.1749 13.4894 16.0482 13.4418 15.858 13.3467ZM12.3874 18.0837H12.3847C11.2494 18.0834 10.136 17.7785 9.16445 17.2021L8.93334 17.0651L6.53867 17.693L7.17796 15.3589L7.02739 15.1197C6.39414 14.1125 6.05956 12.9486 6.06009 11.7534C6.06152 8.26596 8.89991 5.42864 12.3899 5.42864C14.0798 5.42935 15.6684 6.08819 16.8631 7.28374C18.0576 8.4793 18.715 10.0685 18.7147 11.7586C18.7133 15.2464 15.8747 18.0837 12.3874 18.0837ZM17.7723 6.3753C16.3351 4.93673 14.4237 4.14418 12.3874 4.14329C8.1913 4.14329 4.77637 7.55699 4.77477 11.7531C4.77423 13.0942 5.12463 14.4034 5.79094 15.5575L4.71094 19.501L8.74649 18.4429C9.85831 19.0491 11.1102 19.3685 12.3842 19.3691H12.3874C16.5828 19.3691 19.9981 15.955 19.9998 11.7591C20.0007 9.7257 19.2096 7.81353 17.7723 6.3753Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1145_6470"
          x1={12}
          y1={22.2564}
          x2={12}
          y2={-1.74363}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#78CD51" />
          <stop offset={1} stopColor="#A0FC84" />
        </linearGradient>
      </defs>
    </svg>
  </SVGUniqueID>
);
export { WhatsAppIconSolidCircular };
